import React, { Component } from 'react';
import { connect } from 'react-redux';

class SearchString extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
        this.downloadFun=this.downloadFun.bind(this);
    }
    downloadFun(){

    }
    render() { 
        return ( 
            <h3 onClick={this.downloadFun}>Search Reults for <b>{this.props.state.links.links.searchString}</b></h3>
         );
    }
}
const mapStateToProps = (state) => {
    console.log('i am called when store is updated',state)
  
    return {
      state: state
    };
  }
  

   
export default connect(mapStateToProps)(SearchString);
 



// WEBPACK FOOTER //
// ./src/components/SearchString.js